export enum ViewType {
  Grid = 'grid',
  List = 'list',
  Graph = 'graph',
  Edit = 'edit',
}
